import { ControllerParams, CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createEventHandler, getSettingsValue } from '@wix/tpa-settings';
import {
  ButtonState,
  CategoriesTabsState,
  ChallengesCustomEvents,
  ISettingsEvents,
} from './Widget/settingsEvents';
import {
  arrayToObjectAsync,
  getBaseProvidersData,
} from '../../contexts/main/getBaseProvidersData';
import { ScreenNames } from '../../contexts/main/biInterfaces';
import programListSettings from './settingsParams';
import { renderSeoMetatagsList } from '../../services/SeoMetatagsList';
import { getCategoriesInitialData } from '../../contexts/storage-contexts/Categories';
import { getChallengesListInitialData } from '../../contexts/storage-contexts/ChallengesList';
import { getPaidPlansInitialDataForList } from '../../contexts/storage-contexts/PaidPlans';
import { Category } from '@wix/ambassador-achievements-categories-v3-category/types';

const createController: CreateControllerFn = async ({
  controllerConfig,
  flowAPI,
}: ControllerParams) => {
  const { setProps } = flowAPI.controllerConfig;
  const publicData = controllerConfig.config.publicData.COMPONENT || {};

  // settings panel pub/sub https://github.com/wix-private/tpa-settings#events-between-settings-panel-and-applications
  const settingsEventsHandler = createEventHandler<ISettingsEvents>(publicData);
  settingsEventsHandler.on(ChallengesCustomEvents.buttonState, (value) => {
    setProps({
      buttonState: value,
    });
  });

  settingsEventsHandler.on(
    ChallengesCustomEvents.categoriesTabState,
    (categoriesTabsState) => {
      setProps({
        categoriesTabsState,
      });
    },
  );

  settingsEventsHandler.on('setCategoryToPreview', (value: string) => {
    setProps({
      categoryToPreview: value,
    });
  });

  // subscribe on reset. When setting panel is closed
  settingsEventsHandler.onReset(() => {
    setProps({
      buttonState: ButtonState.Default,
      categoriesTabsState: CategoriesTabsState.Regular,
    });
  });

  return {
    async pageReady() {
      const initialProps = {
        ...(await arrayToObjectAsync([
          getBaseProvidersData({
            flowAPI,
          }),
          getChallengesListInitialData(flowAPI),
          getCategoriesInitialData(flowAPI),
          getPaidPlansInitialDataForList(flowAPI),
        ])),
      };

      settingsEventsHandler.on('onCategoryChanged', (category: Category) => {
        setProps({
          categoriesData: {
            ...initialProps.categoriesData,
            categories: initialProps.categoriesData.categories.map((c) => {
              if (c.id === category.id) {
                return category;
              }
              return c;
            }),
          },
        });
      });
      flowAPI.bi.updateDefaults({
        origin: flowAPI.controllerConfig?.wixCodeApi?.window?.viewMode,
        _uuid: flowAPI.controllerConfig?.platformAPIs?.bi?.ownerId,
        screenName: ScreenNames.ChallengeListWidget,
      });

      const chVisible = getSettingsValue(
        flowAPI.controllerConfig.config.publicData.COMPONENT || {},
        programListSettings?.challengesVisible,
      );

      renderSeoMetatagsList(
        flowAPI,
        initialProps?.challengesListData?.memberChallenges || [],
        chVisible,
      );

      setProps(initialProps);
    },
    updateConfig($w, config) {
      // notify (events should be fired)
      settingsEventsHandler.notify(config.publicData.COMPONENT || {});
    },
  };
};

export default createController;
